import { DateTime } from 'luxon';

export const dateFormat = isoTimeStamp => (isoTimeStamp ? DateTime.fromISO(isoTimeStamp).toLocaleString(DateTime.DATE_SHORT) : '');

export const dateTimeFormat = isoTimeStamp => (isoTimeStamp ? DateTime.fromISO(isoTimeStamp).toLocaleString(DateTime.DATETIME_SHORT) : '');
